import type Experiments from '@alltrails/types/Experiments';

export const PRINT_MODAL_EXPERIMENT_KEY = 'web-disco-print-modal';

const isPrintModalEnabled = (experiments?: Experiments): boolean => experiments?.[PRINT_MODAL_EXPERIMENT_KEY]?.value === 'treatment';

export default isPrintModalEnabled;
